export const CaraCerdasList = [
  {
    icon: "/static/images/png/literasi-keuangan/coins_outline.png",
    title: "Rencana & Tujuan Finansial",
    subtitle:
      "Simak artikel dan video mengenai perencanaan keuangan dan raih kebebasan finansial yang kamu inginkan.",
    cardsubtitle: "Saatnya raih kebebasan finansial yang kamu inginkan.",
    link: "/literasi-keuangan/cara-cerdas/rencana_tujuan",
    slug: "rencana_tujuan",
  },
  {
    icon: "/static/images/png/literasi-keuangan/get_loan_outline.png",
    title: "Pengelolaan Cicilan",
    subtitle:
      "Tidak ada kata terlambat untuk belajar. Simak artikel dan video berikut untuk lihat cara bijak belanja dengan cicilan.",
    cardsubtitle: "Cari tahu cara bijak untuk menyicil di era digital.",
    link: "/literasi-keuangan/cara-cerdas/pengelolaan_cicilan",
    slug: "pengelolaan_cicilan",
  },
  {
    icon: "/static/images/png/literasi-keuangan/wallet_security_outline.png",
    title: "Keamanan Online",
    subtitle:
      "Keamanan itu yang utama. Kenali seluk beluk keamanan internet agar jadi bisa terhindar dari kejahatan online atau hal-hal tak diinginkan lainnya.",
    cardsubtitle: "Kenali seluk beluknya agar terhindar dari kejahatan online.",
    link: "/literasi-keuangan/cara-cerdas/keamanan_online",
    slug: "keamanan_online",
  },
  {
    icon: "/static/images/png/literasi-keuangan/business_outline.png",
    title: "Kewirausahaan",
    subtitle:
      "Tak perlu menunda rencana usaha lebih lama. Temukan tips ampuh untuk usahamu dan mulai tanpa ragu!",
    cardsubtitle: "Lihat tips ampuh untuk usahamu dan mulai tanpa ragu!",
    link: "/literasi-keuangan/cara-cerdas/kewirausahaan",
    slug: "kewirausahaan",
  },
];

export const FinansialLiteracyListCategory = [
  {
    name: "Artikel",
    contentType: "article",
    id: 0,
  },
  {
    name: "Video",
    contentType: "video",
    id: 1,
  },
];
